import { compose } from 'recompose';

import SecondaryBarMobileView from './SecondaryBarMobileView';

export default compose()(SecondaryBarMobileView);
